import { useSEO } from '../hooks/useSEO';

/**
 * Stub. Replace with content reviewed by MTC's legal/compliance contact —
 * Loi 09-08 (Maroc) requires identifying the data controller, listing the
 * data collected, the purposes, retention periods, and the user's rights.
 */
export function Privacy() {
  useSEO({
    title: 'Politique de confidentialité',
    description: 'Politique de confidentialité du Moroccan Training Center.',
  });
  return (
    <div className="page-privacy" style={{ maxWidth: 720, margin: '0 auto', padding: '64px 24px' }}>
      <span className="mtc-eyebrow">Mentions légales</span>
      <h1>Politique de confidentialité</h1>
      <p style={{ marginTop: 12, color: 'rgba(15,25,22,0.7)' }}>
        <em>
          Document préliminaire — à finaliser avec un conseil juridique avant mise en production
          (conformité Loi 09-08).
        </em>
      </p>

      <h2 style={{ marginTop: 32 }}>Responsable du traitement</h2>
      <p>
        Le présent site est édité par le Moroccan Training Center (MTC), Boulevard Zerktouni,
        Casablanca, Maroc. Contact :{' '}
        <a href="mailto:contact@mtc.ma">contact@mtc.ma</a>.
      </p>

      <h2 style={{ marginTop: 24 }}>Données collectées</h2>
      <ul>
        <li>
          <strong>Inscription à une formation</strong> : prénom, nom, email, téléphone, ville,
          profession, et toute information complémentaire fournie volontairement.
        </li>
        <li>
          <strong>Cookies</strong> : un cookie technique enregistre votre choix sur ce bandeau de
          consentement. Aucun cookie de mesure d'audience ou de marketing tiers n'est posé sans votre
          accord explicite.
        </li>
      </ul>

      <h2 style={{ marginTop: 24 }}>Finalités</h2>
      <p>
        Vos données sont utilisées pour traiter votre inscription, vous communiquer les informations
        pratiques relatives à la formation, et vous adresser nos communications opérationnelles. Elles
        ne sont ni vendues ni cédées à des tiers à des fins commerciales.
      </p>

      <h2 style={{ marginTop: 24 }}>Vos droits</h2>
      <p>
        Conformément à la Loi 09-08, vous disposez d'un droit d'accès, de rectification, d'opposition
        et de suppression sur vos données personnelles. Adressez votre demande à{' '}
        <a href="mailto:contact@mtc.ma">contact@mtc.ma</a>.
      </p>

      <h2 style={{ marginTop: 24 }}>Conservation</h2>
      <p>
        Les données d'inscription sont conservées pendant la durée nécessaire à la gestion de la
        formation et de la relation pédagogique, augmentée des délais légaux applicables.
      </p>
    </div>
  );
}
